import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PersonTypeComponent from "../../../../parts/person-type-component";

class BranchType extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  UNSAFE_componentWillMount() {}
  render() {
    return (
      <h2 className="text-center">
        Para Começar A Usar, Cadastre Uma Pessoa Física, Jurídica Ou MEI
      </h2>,
      <PersonTypeComponent mei label="Eu sou ..." />
    );
  }
  componentWillUnmount() {}
}

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(BranchType);



// WEBPACK FOOTER //
// ./src/components/pages/branches/create/steps/branch-type.jsx